export const ImageAssetMimeTypes = [
    'image/jpeg',
    'image/png',
    'image/bmp',
    'image/svg+xml',
];

export const AudioAssetMimeTypes = [
    '.mp3',
];

export const AssetMimeTypes = [
    ...ImageAssetMimeTypes,
    ...AudioAssetMimeTypes,
];